import { prepHandleEvent } from "./prepHandleEvent";

export function handleCopy(canvas) {
  return function (event) {
    if (document.activeElement === canvas) {
      event.stopPropagation();
      event.preventDefault();
    }
    var myApp = prepHandleEvent(this, false, null, null);
    if (myApp == null) return;
    myApp.HandleCopy(event);
  };
}
